import { CommonEnums } from 'src/app/shared/common.enums';

export class DxFun {
    dxFun_Id: number;
    nm: string;
    aliasNm: string;
    description: string;
    dbTyp_Id: number;
    outPrec: number;
    outScale: number;
    outDTyp_Id: number;
    outExprVal: string;
    outvalid_Cd: string;
    valid_Cd: string;
    ver: string;
    updateBy: string;
    updateDt: Date;

    constructor() {
        this.setDefaults()
    }

    setDefaults(): void {
        this.dxFun_Id = CommonEnums.defaults.LONG_VAL;
        this.nm = CommonEnums.defaults.STRING_EMPTY;
        this.aliasNm = CommonEnums.defaults.STRING_EMPTY;
        this.description = CommonEnums.defaults.STRING_EMPTY;
        this.dbTyp_Id = CommonEnums.defaults.DEFAULT_INT_VAL;
        this.outPrec = CommonEnums.defaults.DEFAULT_INT_VAL;
        this.outScale = CommonEnums.defaults.DEFAULT_INT_VAL;
        this.outDTyp_Id = CommonEnums.defaults.DEFAULT_INT_VAL;
        this.outExprVal = CommonEnums.defaults.STRING_EMPTY;
        this.outvalid_Cd = CommonEnums.defaults.OUT_VALID_CD;
        this.valid_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.ver = CommonEnums.defaults.STRING_EMPTY;
        this.updateBy = CommonEnums.defaults.STRING_EMPTY;
        this.updateDt = new Date();
    }

    static parse(dxFunTmp: any): DxFun {
        let dxFun: DxFun = new DxFun();
        dxFun.copyFrom(dxFunTmp as DxFun);
        return dxFun;
    }

    getPrimaryKey(): string {
        return this.dxFun_Id.toString();
    }

    copy(): DxFun {
        let dxFunTmp: DxFun = new DxFun();

        dxFunTmp.dxFun_Id = this.dxFun_Id;
        dxFunTmp.nm = this.nm;
        dxFunTmp.aliasNm = this.aliasNm;
        dxFunTmp.description = this.description;
        dxFunTmp.dbTyp_Id = this.dbTyp_Id;
        dxFunTmp.outPrec = this.outPrec;
        dxFunTmp.outScale = this.outScale;
        dxFunTmp.outDTyp_Id = this.outDTyp_Id;
        dxFunTmp.outExprVal = this.outExprVal;
        dxFunTmp.outvalid_Cd = this.outvalid_Cd;
        dxFunTmp.valid_Cd = this.valid_Cd;
        dxFunTmp.ver = this.ver;
        dxFunTmp.updateBy = this.updateBy;
        dxFunTmp.updateDt = this.updateDt;

        return dxFunTmp;
    }

    copyFrom(dxFunTmp: DxFun): void {
        this.dxFun_Id = dxFunTmp.dxFun_Id;
        this.nm = dxFunTmp.nm;
        this.aliasNm = dxFunTmp.aliasNm;
        this.description = dxFunTmp.description;
        this.dbTyp_Id = dxFunTmp.dbTyp_Id;
        this.outPrec = dxFunTmp.outPrec;
        this.outScale = dxFunTmp.outScale;
        this.outDTyp_Id = dxFunTmp.outDTyp_Id;
        this.outExprVal = dxFunTmp.outExprVal;
        this.outvalid_Cd = dxFunTmp.outvalid_Cd;
        this.valid_Cd = dxFunTmp.valid_Cd;
        this.ver = dxFunTmp.ver;
        this.updateBy = dxFunTmp.updateBy;
        this.updateDt = dxFunTmp.updateDt;
    }

    compare(dxFunTmp: DxFun): string {
        let dxFunString: string = this.toString(false);
        let dxFunTmpString: string = dxFunTmp.toString(false);
        if (dxFunString != dxFunTmpString) {
            return dxFunString + ', ' + dxFunTmpString;
        }
        return '';
    }

    toString(isNotCompare: boolean = true): string {
        let str: string = " DxFun [ dxFun_Id=" + this.dxFun_Id + ", nm=" + this.nm + ", aliasNm=" + this.aliasNm +
            ", description=" + this.description + ", dbTyp_Id=" + this.dbTyp_Id + ", outPrec=" + this.outPrec +
            ", outScale=" + this.outScale + ", outDTyp_Id=" + this.outDTyp_Id + ", outExprVal=" + this.outExprVal +
            ", outvalid_Cd=" + this.outvalid_Cd + ", valid_Cd=" + this.valid_Cd+",ver=" + this.ver +", updateBy=" +this.updateBy+ ", updateDt=" + this.updateDt;

        if (isNotCompare) {
            
        }

        str += ']';

        return str;
    }
}
